import { BaseIcon, BaseIconProps } from '../BaseIcon';

// Replace these HTMLAttributes with your correct one
type MatrixIconProps = Omit<BaseIconProps, 'children'>;

export const MatrixIcon = ({ ...props }: MatrixIconProps) => (
  <BaseIcon
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6V18H18V6H6ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5Z"
      fill="#141B4D"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M6 11L18 11L18 13L6 13L6 11Z" fill="#141B4D" />
    <path fillRule="evenodd" clipRule="evenodd" d="M11 18V6H13V18H11Z" fill="#141B4D" />
    <path
      d="M9.5 8.5C9.5 9.05228 9.05228 9.5 8.5 9.5C7.94772 9.5 7.5 9.05228 7.5 8.5C7.5 7.94772 7.94772 7.5 8.5 7.5C9.05228 7.5 9.5 7.94772 9.5 8.5Z"
      fill="#141B4D"
    />
    <path
      d="M9.5 15.5C9.5 16.0523 9.05228 16.5 8.5 16.5C7.94772 16.5 7.5 16.0523 7.5 15.5C7.5 14.9477 7.94772 14.5 8.5 14.5C9.05228 14.5 9.5 14.9477 9.5 15.5Z"
      fill="#141B4D"
    />
    <path
      d="M16.5 8.5C16.5 9.05228 16.0523 9.5 15.5 9.5C14.9477 9.5 14.5 9.05228 14.5 8.5C14.5 7.94772 14.9477 7.5 15.5 7.5C16.0523 7.5 16.5 7.94772 16.5 8.5Z"
      fill="#141B4D"
    />
  </BaseIcon>
);

MatrixIcon.displayName = 'MatrixIcon';
